import { useState, type FC } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/data';

const FAQSection: FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题解答
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            快速找到您关心的问题答案，轻松使用 17c.com
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 text-lg ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div
                className={`transition-all duration-200 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/faq"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多常见问题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;